import Image from 'components/LazyImage/Image';
import React from 'react';
import { BlogContent, BlogContentContainer, Card } from './ContentCard.style';

const ContentCard = ({ item, children }) => {
    return (
      <BlogContentContainer>
        <Card $reverse={item.reverse}>
          <BlogContent>{children}</BlogContent>
          <Image src={item.picture} alt={item.altImage} />
        </Card>
      </BlogContentContainer>
    );
  };
  
  export default ContentCard;